
<form role="form" class="layout-grid" (ngSubmit)="onSubmit_signIn(signInForm)" #signInForm="ngForm" aria-labelledby="aria_page_header">
  @if (!authService.adConfigModel?.isAdEnabled || authService.tellerLogon) {
    <mat-form-field>
      <mat-label>User ID</mat-label>
      <input matInput
        id="main-content-focus"
        [(ngModel)]="signInRequest.userId"
        name="UserId"
        [disabled]="userIdReadOnly"
        #userIdModel="ngModel"
        required
        maxlength="256">
        @if (userIdModel.invalid) {
          <mat-error>{{validationService.getFieldErrorMessage(userIdModel.name, userIdModel, validationService.fieldErrors[userIdModel.name])}}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Password</mat-label>
        <input matInput
          [(ngModel)]="signInRequest.password"
          autocomplete="current-password"
          name="Password"
          type="password"
          #passwordModel="ngModel"
          required
          maxlength="256">
          @if (passwordModel.invalid) {
            <mat-error>{{validationService.getFieldErrorMessage(passwordModel.name, passwordModel)}}</mat-error>
          }
        </mat-form-field>
      }

      <button matButton="filled" color="primary" type="submit" [disabled]="loading">
        @if (!signingIn) {
          <span>Sign In</span>
        }
        @if (signingIn) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </button>

      @if (showSignOut) {
        <button matButton
          type="button"
          (click)="onClick_signOut(signInForm)"
          [disabled]="loading">
          @if (!signingOut) {
            <span>Sign Out</span>
          }
          @if (signingOut) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
      }
    </form>
